export const defaultValue = {
    id: '',
    name: '',
};
